import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { PythonExerciseComponent } from '../python-exercise/python-exercise';
@DecorateUntilDestroy()
@Component({
  selector: 'skypro-python-test-case',
  template: `
    <div [hidden]="true">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonTestCaseComponent implements AfterViewInit {
  private inputs = new BehaviorSubject<string[]>([]);
  private output = new Subject<string>();

  private pythonExerciseComponent = inject(PythonExerciseComponent);

  ngAfterViewInit(): void {
    combineLatest([this.inputs.asObservable(), this.output.asObservable()])
      // Ждем пока все компоненты ниже проинициализируются и зарепортят сюда свои значения
      .pipe(debounceTime(0), take(1), takeUntilDestroyed(this))
      .subscribe(([inputs, output]) => {
        this.pythonExerciseComponent.addTestCase({
          output,
          inputs,
        });
      });
  }

  addInput(input: string): void {
    const inputs = this.inputs.getValue();
    this.inputs.next([...inputs, input]);
  }

  addOutput(output: string): void {
    this.output.next(output);
  }
}
